import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHierarchy6 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "hierarchy-6" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: 15.748,
			width: 7.5,
			height: 7.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 8.25,
			y: .748,
			width: 7.5,
			height: 7.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 15.75,
			y: 15.748,
			width: 7.5,
			height: 7.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M4.5,15.748v-1.5a1.5,1.5,0,0,1,1.5-1.5H18a1.5,1.5,0,0,1,1.5,1.5v1.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 8.248,
			x2: 12,
			y2: 12.748
		})
	]
});
export default SvgHierarchy6;
